<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/equipment/adaptEquipmentAllot"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeiSN')">
						<el-input v-model="yt.conditions.sn"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeixinghao')">
						<el-input v-model="yt.conditions.modelCode"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeileixing')">
						<yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.typeId">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('suoshuzuzhi')">
						<yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('guishuzhujiSN')">
						<el-input v-model="yt.conditions.belongSn"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chuchangriqi')">
						<yi_time_input :format="'yyyy-MM-dd'" type="daterange"
							:start.sync="yt.conditions.leaveFactoryDateStart"
							:end.sync="yt.conditions.leaveFactoryDateEnd">
						</yi_time_input>
					</el-form-item>
					
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({materialId: $attrs.materialId,
					mouldId: $attrs.mouldId})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('muju', scope.row,'w2')">{{$t('muju')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row,'w3')">{{$t('baoyangxiang')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/setting/shiftType/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('baoyangfenzu')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangleixing')" required>
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('shoucibaoyang')" :value="1"></el-option>
							<el-option :label="$t('dingqibaoyang')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhouqileixing')" required>
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('hemocishu')" :value="1"></el-option>
							<el-option :label="$t('antian')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhouqichangdu')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyanghaoshi(xiaoshi)')" required>
						<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.code"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/setting/shiftType/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">

					<el-form-item :label="$t('baoyangfenzu')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangleixing')" required>
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('shoucibaoyang')" :value="1"></el-option>
							<el-option :label="$t('dingqibaoyang')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhouqileixing')" required>
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('hemocishu')" :value="1"></el-option>
							<el-option :label="$t('antian')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhouqichangdu')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyanghaoshi(xiaoshi)')" required>
						<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.code"></el-input>
					</el-form-item>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/setting/shiftType/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_screen_printing_management_work_order_execution_equipment_list',
		components: {
			// mold,
			// item
		},
		data() {
			return {
				list: [],
				// organizationList: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'name',
					width: 130
				}, {
					label: 'shebeiSN',
					prop: 'sn',
					width: 130
				}, {
					label: 'shebeixinghao',
					prop: 'model.code',
				}, {
					label: 'shebeileixing',
					prop: 'typeId',
					type: 'dictionary',
					key: 'EQUIPMENT_TYPES',
					width: 130
				}, {
					label: 'suoshuzuzhi',
					prop: 'org.name',
					width: 180
				}, {
					label: 'chuchangriqi',
					prop: 'leaveFactoryDate',
					type: 'time',
					format: 'YYYY-MM-DD',
				}, {
					label: 'baofeiriqi',
					prop: 'scrapData',
					type: 'time',
					format: 'YYYY-MM-DD'
				}, 	{
					label: 'dunwei',
					prop: 'tonnage',
				}, {
					label: 'guishuzhujiSN',	
					prop: 'belongSn',
				}, {
					label: 'paixu',
					prop: 'sort',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 230,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					materialId: this.$attrs.materialId,
					mouldId: this.$attrs.mouldId,
				}
				this.yt.SELECT_URL = "/web/equipment/standing_book/getEquipmentByIds"
				this.yt.SELECT_RESULT_KEY = "data"
				this.yt.SELECT_ID = "id"
				this.yt.SELECT_TITLE = "name"
				this.yt.get(1);
				// this.getOrganizationList();
			}, 300)

		},
		methods: {
			// async getOrganizationList() {
			// 	let response = await this.http.get('/web/setting/org/page', {
			// 		params: {
			// 			pageNum: 1,
			// 			pageSize: 1000
			// 		}
			// 	})
			// 	this.organizationList = response.data.rows
			// },
			// 重置
			clear() {
				this.yt.conditions = {
					pageNum: 1,
					pageSize: 10
				}
				this.yt.get(1)
			},
		}
	};
</script>
